import axios from '../utils/axios';

export default function getUnverifiedRecruiters(adminId, params) {
    return axios.get(`/admin/${adminId}/get-unverified-recruiters`, { params });
}
